import { Link, useLocation } from 'react-router-dom';
import classNames from 'classnames';

import { LockIcon } from '../../icons';

import styles from './_index.module.scss';

interface TabsProps {
  onChange?: (value: string | number) => void;
  options?: Array<{ label: React.ReactNode; value: string | number }>;
  routes?: Array<{
    label: React.ReactNode;
    to: { pathname: string; search?: string; hash?: string } | string;
    is_active?: boolean;
    isDisabled?: boolean;
    is_locked?: boolean;
  }>;
  value?: string | number;
}

const Tabs = ({ onChange = () => {}, options, routes, value }: TabsProps) => {
  const { pathname } = useLocation();
  const className = styles['tabs'];

  if (routes) {
    return (
      <ul className={className}>
        {routes.map((route, index) => {
          const url = typeof route.to === 'object' ? route.to.pathname : route.to;

          const listClassNames = classNames({
            [styles['is-active']]: pathname?.includes(url) || route?.is_active,
            [styles['is-disabled']]: route?.isDisabled,
            [styles['is-locked']]: route?.is_locked,
          });

          return (
            <li className={listClassNames} data-testid={`tab-${index}`} key={`route-${index}`}>
              <Link replace to={route?.to}>
                {route?.label}
              </Link>
              {route?.is_locked && <LockIcon />}
            </li>
          );
        })}
      </ul>
    );
  }

  if (options) {
    return (
      <ul className={className}>
        {options?.map((option, index) => {
          const listClassNames = classNames({
            [styles['is-active']]: option?.value === value,
          });

          return (
            <li
              className={listClassNames}
              data-testid={`option-${index}`}
              key={`option-${index}`}
              tabIndex={0}
            >
              <span onClick={() => onChange(option?.value)}>{option?.label}</span>
            </li>
          );
        })}
      </ul>
    );
  }

  return null;
};

export default Tabs;
